export const GET_WAREHOUSES = "GET_WAREHOUSES";
export const GET_WAREHOUSES_SUCCESS = "GET_WAREHOUSES_SUCCESS";
export const GET_WAREHOUSES_FAIL = "GET_WAREHOUSES_FAIL";

export const SET_WAREHOUSE_WRITE_ENABLED = "SET_WAREHOUSE_WRITE_ENABLED";
